"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TournamentCard = function (_a) {
    var _b, _c, _d;
    var baseTournament = _a.baseTournament, topScores = _a.topScores;
    var t = (0, next_intl_1.useTranslations)('translation');
    var router = (0, navigation_1.useRouter)();
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var onClickHandler = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang("/tournaments/finished/".concat(baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.slug)));
    }, [router, baseTournament, generateUrlWithLang]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container) },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.image, style: {
                backgroundImage: "url(".concat((_b = baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.images) === null || _b === void 0 ? void 0 : _b.banner, ")"),
            } }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.winner },
            t('winner'),
            ":"),
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.winner, " ").concat(styles_module_scss_1.default.bold) }, (_d = (_c = topScores === null || topScores === void 0 ? void 0 : topScores[0]) === null || _c === void 0 ? void 0 : _c.user) === null || _d === void 0 ? void 0 : _d.nickname),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
            react_1.default.createElement("h3", null, translateLocale(baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.name))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.button },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "240px", maxWidth: "100%", className: "participate", height: breakpoints.mobile ? '32px' : '48px', onClick: onClickHandler }, t('results')))));
};
exports.default = TournamentCard;
